import Tags from "../common/Rentals/Tags";
export default Tags;
